module.exports = __webpack_public_path__ + "static/media/wegWhite.1164f3ba.svg";